import React, { useContext } from "react";
import CurrentUserContext from "../../contexts/CurrentUserContext";
import "./SubscriptionCheck.css";
import {
  getLastEndDate,
  hasCategory,
  isSubscriptionActive,
} from "../../utils/subscription.js";

function SubscriptionCheck({ handleSignOut }) {
  const currentUser = useContext(CurrentUserContext);

  const lastEndDate = getLastEndDate(currentUser.subscription);
  if (lastEndDate) {
    const now = new Date();

    if (now > lastEndDate) {
      const day = lastEndDate.getDate();
      const month = lastEndDate.getMonth() + 1;
      const year = lastEndDate.getFullYear();
      const time = `${lastEndDate.getHours()}:${lastEndDate.getMinutes()}`;

      return (
        <div className="subscription-check" onClick={() => window.location.reload()}>
          <div className="subscription-check__message">
            Your subscription has expired on {day}/{month}/{year} at {time}
          </div>
          <div className="user-profile__logout" onClick={handleSignOut}>Sign Out</div>
        </div>
      );
    }
  }

  if (!isSubscriptionActive(currentUser.subscription)) { // поменял местами
    return (
      <div className="subscription-check" onClick={() => window.location.reload()}>
        <div className="subscription-check__message">Subscription is not active</div>
        <div className="user-profile__logout" onClick={handleSignOut}>Sign Out</div>
      </div>
    );
  }

  if (!hasCategory(currentUser.subscription, "pp")){
    return (
      <div className="subscription-check" onClick={() => window.location.reload()}>
        <div className="subscription-check__message">Subscription for Premiere Pro is not active</div>
        <div className="user-profile__logout" onClick={handleSignOut}>Sign Out</div>
      </div>
    );
  }

  return null;
}

export default SubscriptionCheck;

